import { type PropsWithChildren, forwardRef } from "react";

import type { IconButtonProps } from "./IconButton.types";
import { cn } from "$/lib/utils/functions/misc.functions";

const IconButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<IconButtonProps>
>(
  (
    {
      className,
      isLoading,
      disabled,
      type,
      icon,
      theme = "primary",
      ...iconButtonProps
    },
    forwardedRef,
  ) => {
    return (
      <button
        ref={forwardedRef}
        type={type || "button"}
        aria-busy={isLoading}
        className={cn(
          "flex h-10 w-10 items-center justify-center rounded-full font-medium transition-all duration-200 hover:opacity-75 hover:shadow-sm active:opacity-50 disabled:cursor-not-allowed disabled:opacity-50 aria-busy:cursor-wait",
          {
            "bg-primary text-white": theme === "primary",
            "bg-secondary text-white": theme === "secondary",
            "bg-danger text-white": theme === "danger",
          },
          className,
        )}
        disabled={disabled || isLoading}
        {...iconButtonProps}
      >
        {isLoading ? (
          <span
            className={cn(
              "border-snow h-5 w-5 animate-spin rounded-full border-b-2 border-t-2",
            )}
          />
        ) : (
          icon
        )}
      </button>
    );
  },
);

IconButton.displayName = "IconButton";

export default IconButton;
